/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { capitalize } from '@veeam-vspc/core';
import { colors as palette } from '@veeam-vspc/components';

import { BaseTrendChart } from '../../../BaseTrendChart';
import { ConsumedStorageService } from './services/consumed-storage.service';
import { useLang } from 'views/providers/LangProvider/hooks';

export const ConsumedStorage: React.FC = () => {
    const lang = useLang();

    const params = {
        colors: [palette.B400],
        yTitle: lang.SIZE,
    };

    return (
        <BaseTrendChart
            params={params}
            service={ConsumedStorageService}
            title={{ text: capitalize(lang.CONSUMED_STORAGE) }}
        />
    );
};
